import { useState } from "react";
import { Button, Typography } from "@mui/material";
import { Field, useFormikContext } from "formik";
import { FormikAutocomplete } from "@poseidon/ui/components/form/FormikAutocomplete";

export default function NestedField({
  field,
  title,
  renderPreview,
  options,
  getOptionSelected,
  ...props
}) {
  const [shouldUpdate, setShouldUpdate] = useState(false);
  const { isSubmitting } = useFormikContext();

  if (options && shouldUpdate) {
    return (
      <Field
        component={FormikAutocomplete}
        name="dealer"
        label="Dealer"
        options={options}
        textFieldProps={{
          fullWidth: true,
          margin: "normal",
          variant: "outlined",
        }}
        {...props}
      />
    );
  }

  return (
    <>
      <Typography variant="subTitle">{title}</Typography>
      {renderPreview(field)}
      {options && (
        <Button
          variant="contained"
          color="secondary"
          style={{ margin: "10px 0" }}
          onClick={() => setShouldUpdate(true)}
          disabled={isSubmitting}
        >
          Change {title}
        </Button>
      )}
    </>
  );
}
